import Vue from "vue";
import Vuex from "vuex";
// import sidebar from "./sidebar";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    expanded: false,
    pnSearch: '',
  },
  getters: {
    expanded(state) {
      return state.expanded;
    },
    pnSearch(state) {
      return state.pnSearch;
    }
  },
  mutations: {
    setExpanded(state, expanded) {
      this.state.expanded = expanded;
    },
    setPnSearch(state, pnSearch) {
      this.state.pnSearch = pnSearch;
    }
  },
  actions: {
    updateExpanded({commit}, expanded) {
      commit('setExpanded', expanded)
    }
  },
  modules: {
    // sidebar
  }
});
